var render = function render(){
  var _vm$notice_sign_off_f, _vm$notice_sign_off_f2, _vm$notice_sign_off_f3, _vm$notice_sign_off_f4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "p-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "bg-white p-3 rounded"
        }, [_c('div', {
          staticClass: "d-flex w-full btn-group"
        }, _vm._l(_vm.tabs, function (tab, i) {
          return _c('button', {
            key: i,
            staticClass: "btn btn-outline-primary btn-menu d-flex justify-content-center align-items-center p-4",
            class: {
              'btn-menu-active': _vm.dashboard === tab.title
            },
            on: {
              "click": function click($event) {
                _vm.dashboard = tab.title;
              },
              "mouseover": function mouseover($event) {
                tab.isHover = true;
              },
              "mouseleave": function mouseleave($event) {
                tab.isHover = false;
              }
            }
          }, [_c(tab.icon, {
            tag: "component",
            staticClass: "mr-2",
            attrs: {
              "color": tab.isHover || _vm.dashboard === tab.title ? 'white' : '#0088AF'
            }
          }), _vm._v(" " + _vm._s(tab.title) + " ")], 1);
        }), 0)])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "iq-edit-list-data"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "pills-tabContent-2"
    }
  }, [_vm.dashboard == 'CREW' ? [_c('b-row', {
    staticClass: "mb-4 px-1"
  }, _vm._l(_vm.summaries, function (item, i) {
    return _c('b-col', {
      key: i,
      staticClass: "p-2",
      attrs: {
        "lg": "3",
        "md": "4",
        "sm": "6"
      }
    }, [_c('div', {
      staticClass: "bg-white rounded-2 p-4 d-flex cursor-pointer card-animate",
      staticStyle: {
        "border-radius": "12px"
      },
      on: {
        "click": item.action
      }
    }, [_c('div', {
      staticClass: "iq-card-icon",
      style: "background:".concat(item.color, " ; border-radius: 10px")
    }, [_c(item.icon, {
      tag: "component"
    })], 1), _c('div', {
      staticClass: "ml-3"
    }, [_c('h4', [_c('strong', [_vm._v(_vm._s(item.value))])]), _c('h5', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(item.label))])])])]);
  }), 1), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("LIST CREW")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mb-2"
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Search",
            "label-for": "search"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "text",
            "placeholder": "Ketikan Nama",
            "disabled": _vm.crewList.loading
          },
          model: {
            value: _vm.crewList.params.fullname,
            callback: function callback($$v) {
              _vm.$set(_vm.crewList.params, "fullname", $$v);
            },
            expression: "crewList.params.fullname"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Fleet",
            "label-for": "Fleet"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.fleetOptions,
            "reduce": function reduce(fleetOptions) {
              return fleetOptions.value;
            },
            "placeholder": "Select Kapal",
            "disabled": _vm.crewList.loading
          },
          model: {
            value: _vm.crewList.params.vehicle_id,
            callback: function callback($$v) {
              _vm.$set(_vm.crewList.params, "vehicle_id", $$v);
            },
            expression: "crewList.params.vehicle_id"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Jabatan",
            "label-for": "jabatan"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.optionsPosition,
            "size": "lg",
            "disabled": _vm.crewList.loading
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Jabatan...")])];
            },
            proxy: true
          }], null, false, 2674637495),
          model: {
            value: _vm.crewList.params.position_id,
            callback: function callback($$v) {
              _vm.$set(_vm.crewList.params, "position_id", $$v);
            },
            expression: "crewList.params.position_id"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Status",
            "label-for": "status"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.optionsEmployeeStatusFilter,
            "size": "lg",
            "disabled": _vm.crewList.loading,
            "placeholder": "Pilih status crew..."
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Status...")])];
            },
            proxy: true
          }], null, false, 795671696),
          model: {
            value: _vm.crewList.params.status,
            callback: function callback($$v) {
              _vm.$set(_vm.crewList.params, "status", $$v);
            },
            expression: "crewList.params.status"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Join on Board",
            "label-for": "Join on Board"
          }
        }, [_c('date-picker', {
          staticClass: "w-100",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "date",
            "range": "",
            "placeholder": "Select date range",
            "disabled": _vm.crewList.loading
          },
          on: {
            "change": _vm.onCrewChangeDateJob
          },
          model: {
            value: _vm.dateRangeJob,
            callback: function callback($$v) {
              _vm.dateRangeJob = $$v;
            },
            expression: "dateRangeJob"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Sign Off",
            "label-for": "Sign Off"
          }
        }, [_c('date-picker', {
          staticClass: "w-100",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "date",
            "range": "",
            "placeholder": "Select date range",
            "disabled": _vm.crewList.loading
          },
          on: {
            "change": _vm.onCrewChangeDate
          },
          model: {
            value: _vm.dateRange,
            callback: function callback($$v) {
              _vm.dateRange = $$v;
            },
            expression: "dateRange"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "w-100 h-100 d-flex align-items-end"
        }, [_c('b-button', {
          staticClass: "mb-3 mr-1 w-100 py-2",
          attrs: {
            "variant": "success",
            "disabled": _vm.crewList.loading
          },
          on: {
            "click": _vm.filterCrewList
          }
        }, [_vm._v("Filter Data"), _c('i', {
          staticClass: "fa fa-search ml-2"
        })])], 1)]), _c('b-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('hr')]), _c('hr')], 1)], 1), _c('div', {
          staticClass: "d-flex align-items-center justify-content-end mb-2"
        }), _c('div', {
          staticClass: "d-flex align-items-end justify-content-end"
        }, [_c('span', {
          staticClass: "mr-1"
        }, [_vm._v("Total Crew: ")]), _c('strong', [_vm._v(_vm._s(_vm.crewList.meta.total))])]), _c('TableContentCrewList', {
          attrs: {
            "table-data": _vm.crewList.data,
            "indexes": _vm.crewList.meta.indexes,
            "current-page": _vm.crewList.meta.currentPage,
            "isPreview": false
          },
          scopedSlots: _vm._u([{
            key: "table-action",
            fn: function fn() {
              return [_c('div', [_c('b-button', {
                staticClass: "mr-2",
                attrs: {
                  "variant": "outline-primary"
                }
              }, [_c('div', {
                staticClass: "d-flex gap-2 align-items-center"
              }, [_c('span', [_vm._v("Import")]), _c('i', {
                staticClass: "fa fa-download ml-2"
              })])]), _c('b-button', {
                staticClass: "mr-2",
                attrs: {
                  "variant": "primary",
                  "disabled": _vm.crewList.loading
                },
                on: {
                  "click": function click($event) {
                    return _vm.exportCrewList();
                  }
                }
              }, [_vm.crewList.loading ? _c('span', {
                staticClass: "spinner-border spinner-border-sm"
              }) : _c('div', {
                staticClass: "d-flex gap-2 align-items-center"
              }, [_c('span', [_vm._v("Export")]), _c('i', {
                staticClass: "fa fa-upload ml-2"
              })])]), _c('router-link', {
                attrs: {
                  "to": "/crewing/add-crew"
                }
              }, [_c('b-button', {
                staticClass: "mr-2",
                attrs: {
                  "variant": "info"
                }
              }, [_c('i', {
                staticClass: "fa fa-plus"
              }), _vm._v("   Create Data Crew")])], 1)], 1)];
            },
            proxy: true
          }], null, false, 3673434320),
          model: {
            value: _vm.form_crew,
            callback: function callback($$v) {
              _vm.form_crew = $$v;
            },
            expression: "form_crew"
          }
        }), _vm.crewList.data.body.length > 0 ? _c('div', {
          staticClass: "mt-3"
        }, [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.crewList.meta.total,
            "per-page": _vm.crewList.meta.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.getCrewList
          },
          model: {
            value: _vm.crewList.meta.currentPage,
            callback: function callback($$v) {
              _vm.$set(_vm.crewList.meta, "currentPage", $$v);
            },
            expression: "crewList.meta.currentPage"
          }
        })], 1) : _c('p', {
          staticClass: "text-center my-4"
        }, [_vm._v("List crew tidak ada.")])];
      },
      proxy: true
    }], null, false, 963846589)
  }), _c('b-modal', {
    attrs: {
      "id": "notice_sign_off",
      "size": "md",
      "title": "Notice Sign Off",
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSaveNoticeSignOff
    }
  }, [_c('b-row', [_c('b-form-group', {
    staticClass: "col-sm-12",
    attrs: {
      "label": "Reason Sign Off"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.options_signoff_reasons,
      "reduce": function reduce(options_signoff_reasons) {
        return options_signoff_reasons.value;
      },
      "placeholder": "Select Type of Vehicle",
      "required": ""
    },
    model: {
      value: _vm.notice_sign_off_form.reason_sign_off_id,
      callback: function callback($$v) {
        _vm.$set(_vm.notice_sign_off_form, "reason_sign_off_id", $$v);
      },
      expression: "notice_sign_off_form.reason_sign_off_id"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-sm-12",
    attrs: {
      "label": "Notice Off"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local",
      "id": "join_onboard",
      "required": ""
    },
    model: {
      value: _vm.notice_sign_off_form.notice_off,
      callback: function callback($$v) {
        _vm.$set(_vm.notice_sign_off_form, "notice_off", $$v);
      },
      expression: "notice_sign_off_form.notice_off"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show")])], 1), _c('b-form-group', {
    staticClass: "col-sm-12",
    attrs: {
      "label": "Detail Notice Off"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "type": "text",
      "id": "detail_notice_off",
      "required": "",
      "placeholder": "Detail notice sign off..."
    },
    model: {
      value: _vm.notice_sign_off_form.detail_notice_off,
      callback: function callback($$v) {
        _vm.$set(_vm.notice_sign_off_form, "detail_notice_off", $$v);
      },
      expression: "notice_sign_off_form.detail_notice_off"
    }
  })], 1), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "label": "attachment_notice_off",
      "for": "attachment_notice_off"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Attachment File")])]), _c('div', [_c('b-form-group', {
    attrs: {
      "label-for": "attachment_notice_off"
    }
  }, [_c('b-form-file', {
    attrs: {
      "id": "attachment_notice_off",
      "accept": "image/*,application/*"
    },
    model: {
      value: _vm.notice_sign_off_form.attachment_notice_off,
      callback: function callback($$v) {
        _vm.$set(_vm.notice_sign_off_form, "attachment_notice_off", $$v);
      },
      expression: "notice_sign_off_form.attachment_notice_off"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" File Type * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")])], 1)], 1), (_vm$notice_sign_off_f = _vm.notice_sign_off_form) !== null && _vm$notice_sign_off_f !== void 0 && (_vm$notice_sign_off_f2 = _vm$notice_sign_off_f.attachment_notice_off) !== null && _vm$notice_sign_off_f2 !== void 0 && _vm$notice_sign_off_f2.name ? _c('b-form-text', {
    staticClass: "text-muted"
  }, [_vm._v(" File Name: " + _vm._s((_vm$notice_sign_off_f3 = _vm.notice_sign_off_form) === null || _vm$notice_sign_off_f3 === void 0 ? void 0 : (_vm$notice_sign_off_f4 = _vm$notice_sign_off_f3.attachment_notice_off) === null || _vm$notice_sign_off_f4 === void 0 ? void 0 : _vm$notice_sign_off_f4.name) + " ")]) : _vm._e()], 1)])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": '6'
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "block": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('notice_sign_off');
      }
    }
  }, [_vm._v("Close")])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "block": "",
      "type": "submit",
      "disabled": _vm.notice_sign_off_loading
    }
  }, [!_vm.notice_sign_off_loading ? _c('i', {
    staticClass: "fa fa-file-signature"
  }) : _vm._e(), !_vm.notice_sign_off_loading ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.notice_sign_off_loading ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _vm._e()])], 1)], 1)], 1)])] : _vm._e(), _vm.dashboard == 'CANDIDATE' ? [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("CANDIDATE")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$candidateProfile;
        return [_c('div', {
          staticClass: "mb-2"
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Search",
            "label-for": "search"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "text",
            "placeholder": "Ketikan Nama",
            "disabled": _vm.candidateList.loading
          },
          model: {
            value: _vm.candidateList.params.full_name,
            callback: function callback($$v) {
              _vm.$set(_vm.candidateList.params, "full_name", $$v);
            },
            expression: "candidateList.params.full_name"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Jabatan",
            "label-for": "jabatan"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.optionsPosition,
            "size": "lg",
            "disabled": _vm.candidateList.loading
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Jabatan...")])];
            },
            proxy: true
          }], null, false, 2674637495),
          model: {
            value: _vm.candidateList.params.position_id,
            callback: function callback($$v) {
              _vm.$set(_vm.candidateList.params, "position_id", $$v);
            },
            expression: "candidateList.params.position_id"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Status",
            "label-for": "status"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.statusCandidate,
            "size": "lg",
            "disabled": _vm.candidateList.loading
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": ''
                }
              }, [_vm._v("Pilih Status...")])];
            },
            proxy: true
          }], null, false, 1881919403),
          model: {
            value: _vm.candidateList.params.status,
            callback: function callback($$v) {
              _vm.$set(_vm.candidateList.params, "status", $$v);
            },
            expression: "candidateList.params.status"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "2 pr-0"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Jadwal Interview",
            "label-for": "jadawal-interview"
          }
        }, [_c('date-picker', {
          staticClass: "w-100",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "datetime",
            "range": "",
            "placeholder": "Select date range",
            "disabled": _vm.candidateList.loading
          },
          on: {
            "change": _vm.onCandidateChangeDate
          },
          model: {
            value: _vm.dateRange,
            callback: function callback($$v) {
              _vm.dateRange = $$v;
            },
            expression: "dateRange"
          }
        })], 1)], 1), _c('b-col', {
          staticClass: "d-flex align-items-end",
          attrs: {
            "md": "1"
          }
        }, [_c('b-button', {
          staticStyle: {
            "margin-bottom": "1.3rem"
          },
          attrs: {
            "variant": "success",
            "disabled": _vm.candidateList.loading
          },
          on: {
            "click": _vm.filterCandidateList
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })])], 1)], 1), _c('div', {
          staticClass: "d-flex justify-content-end w-100 mb-3"
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "outline-primary"
          }
        }, [_c('div', {
          staticClass: "d-flex gap-2 align-items-center"
        }, [_c('span', [_vm._v("Import")]), _c('i', {
          staticClass: "fa fa-download ml-2"
        })])]), _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "primary",
            "disabled": _vm.candidateList.loading
          },
          on: {
            "click": function click($event) {
              return _vm.exportCandidateList();
            }
          }
        }, [_vm.candidateList.loading ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _c('div', {
          staticClass: "d-flex gap-2 align-items-center"
        }, [_c('span', [_vm._v("Export")]), _c('i', {
          staticClass: "fa fa-upload ml-2"
        })])]), _c('router-link', {
          attrs: {
            "to": "/crewing/add-candidate"
          }
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "info"
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v("   Create Data Candidate")])], 1)], 1)], 1), _c('TableContentCandidateList', {
          attrs: {
            "table-data": _vm.candidateList.data,
            "indexes": _vm.candidateList.meta.indexes,
            "current-page": _vm.candidateList.meta.currentPage
          },
          model: {
            value: _vm.form_candidate,
            callback: function callback($$v) {
              _vm.form_candidate = $$v;
            },
            expression: "form_candidate"
          }
        }), _vm.candidateList.data.body.length > 0 ? _c('div', {
          staticClass: "d-flex align-items-center justify-content-between mt-3"
        }, [_c('div', [_c('span', {
          staticClass: "mr-1"
        }, [_vm._v("Total Candidate: ")]), _c('strong', [_vm._v(_vm._s(_vm.candidateList.meta.total))])]), _c('b-pagination', {
          attrs: {
            "total-rows": _vm.candidateList.meta.total,
            "per-page": _vm.candidateList.meta.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.getCandidateList
          },
          model: {
            value: _vm.candidateList.meta.currentPage,
            callback: function callback($$v) {
              _vm.$set(_vm.candidateList.meta, "currentPage", $$v);
            },
            expression: "candidateList.meta.currentPage"
          }
        })], 1) : _c('p', {
          staticClass: "text-center my-4"
        }, [_vm._v("List candidate tidak ada.")]), _c('b-modal', {
          attrs: {
            "id": "setup-interview",
            "size": "lg",
            "title": "Set Interview",
            "cancel-title": "Close",
            "hide-footer": ""
          }
        }, [_c('form', {
          attrs: {
            "action": "#",
            "method": "post"
          },
          on: {
            "submit": _vm.onSaveSetInterview
          }
        }, [_c('b-row', {
          staticClass: "mb-3"
        }, [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Expert User *",
            "label-for": "expert_user"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.optionsExpertUsers,
            "reduce": function reduce(optionsExpertUsers) {
              return optionsExpertUsers.value;
            },
            "placeholder": "Select Type of Expert User",
            "required": ""
          },
          model: {
            value: _vm.form.setInterviewCandidate.expert_user_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form.setInterviewCandidate, "expert_user_id", $$v);
            },
            expression: "\n                              form.setInterviewCandidate.expert_user_id\n                            "
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Interview Date & Time",
            "label-for": "interview_date"
          }
        }, [_c('date-picker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "required": "",
            "type": "datetime",
            "placeholder": "Select date range",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.form.setInterviewCandidate.date_interview,
            callback: function callback($$v) {
              _vm.$set(_vm.form.setInterviewCandidate, "date_interview", $$v);
            },
            expression: "form.setInterviewCandidate.date_interview"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "for Position *",
            "label-for": "expert_user"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.optionsPosition,
            "size": "lg",
            "required": ""
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Select Position")])];
            },
            proxy: true
          }], null, false, 3227914447),
          model: {
            value: _vm.form.setInterviewCandidate.position_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form.setInterviewCandidate, "position_id", $$v);
            },
            expression: "form.setInterviewCandidate.position_id"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Lokasi",
            "label-for": "expert_user"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "text",
            "required": ""
          },
          model: {
            value: _vm.form.setInterviewCandidate.location,
            callback: function callback($$v) {
              _vm.$set(_vm.form.setInterviewCandidate, "location", $$v);
            },
            expression: "form.setInterviewCandidate.location"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Urgensi",
            "label-for": "interview_date"
          }
        }, [_vm._l(_vm.typeInterview, function (item, index) {
          return [_c('b-form-radio', {
            key: index,
            staticClass: "custom-radio-color-checked",
            attrs: {
              "inline": "",
              "color": item.color,
              "name": "color",
              "value": item.value,
              "disabled": item.disabled,
              "required": ""
            },
            model: {
              value: _vm.form.setInterviewCandidate.urgensi,
              callback: function callback($$v) {
                _vm.$set(_vm.form.setInterviewCandidate, "urgensi", $$v);
              },
              expression: "form.setInterviewCandidate.urgensi"
            }
          }, [_c('strong', [_c('h5', [_vm._v(_vm._s(item.label))])])])];
        })], 2)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Notes (Candidate)",
            "label-for": "interview_date"
          }
        }, [_c('wysiwyg', {
          attrs: {
            "required": ""
          },
          model: {
            value: _vm.form.setInterviewCandidate.notes_set_interview,
            callback: function callback($$v) {
              _vm.$set(_vm.form.setInterviewCandidate, "notes_set_interview", $$v);
            },
            expression: "\n                              form.setInterviewCandidate.notes_set_interview\n                            "
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Notes (Interviewer)",
            "label-for": "interview_date"
          }
        }, [_c('wysiwyg', {
          attrs: {
            "required": ""
          },
          model: {
            value: _vm.form.setInterviewCandidate.notes_set_interview_user,
            callback: function callback($$v) {
              _vm.$set(_vm.form.setInterviewCandidate, "notes_set_interview_user", $$v);
            },
            expression: "\n                              form.setInterviewCandidate\n                                .notes_set_interview_user\n                            "
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('h3', [_vm._v("Eskalasi Notification User")]), _c('hr')]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Expert User *",
            "label-for": "expert_user"
          }
        }, _vm._l(_vm.form.setInterviewCandidate.notification, function (state, index) {
          return _c('div', {
            key: index,
            staticClass: "mb-3 align-content-center w-auto d-flex"
          }, [_c('v-select', {
            staticClass: "w-100 mr-2",
            attrs: {
              "label": "text",
              "options": _vm.optionsExpertUsers,
              "reduce": function reduce(optionsExpertUsers) {
                return optionsExpertUsers.value;
              },
              "placeholder": "Select Type of Expert User",
              "required": ""
            },
            model: {
              value: state.expert_user_id,
              callback: function callback($$v) {
                _vm.$set(state, "expert_user_id", $$v);
              },
              expression: "state.expert_user_id"
            }
          }), _vm.form.setInterviewCandidate.notification.length > 1 && index > 0 ? _c('b-button', {
            staticClass: "w-20",
            attrs: {
              "variant": "danger",
              "size": "sm"
            },
            on: {
              "click": function click() {
                return _vm.deleteNotificationUser(index);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash"
          })]) : _vm._e()], 1);
        }), 0), _c('b-button', {
          attrs: {
            "block": "",
            "variant": "info",
            "size": "md"
          },
          on: {
            "click": _vm.addNotificationUser
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" Add More Data ")])], 1)], 1), _c('b-row', [_c('b-col', {
          attrs: {
            "md": '6'
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "secondary",
            "block": ""
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('setup-interview');
            }
          }
        }, [_vm._v("Close")])], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "block": "",
            "type": "submit",
            "disabled": _vm.saving
          }
        }, [!_vm.saving ? _c('i', {
          staticClass: "fa fa-file-signature"
        }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.saving ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _vm._e()])], 1)], 1)], 1)]), _c('b-modal', {
          attrs: {
            "id": "verification_document",
            "size": "md",
            "title": "Verification Document",
            "cancel-title": "Close",
            "hide-footer": ""
          }
        }, [_c('form', {
          attrs: {
            "action": "#",
            "method": "post"
          },
          on: {
            "submit": _vm.onSaveVerificationDocument
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("LIST DOCUMENT")])])]), _vm._l(_vm.master_list_document, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            attrs: {
              "width": "90%"
            }
          }, [_c('strong', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.document_name))])]), _c('td', {
            attrs: {
              "width": "10%"
            }
          }, [(state === null || state === void 0 ? void 0 : state.status_checklist) === 1 ? _c('i', {
            staticClass: "fa fa-check text-primary"
          }) : _c('i', {
            staticClass: "fa fa-ban text-primary"
          })])]);
        }), _c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("VERIFICATION KEMENHUB")])])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Seaferer code verification")])])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label-for": "seaferer_code_verification"
          }
        }, [_c('b-form-file', {
          attrs: {
            "id": "seaferer_code_verification",
            "accept": "image/*,application/*",
            "required": ""
          },
          model: {
            value: _vm.form_verification.seaferer_code_verification,
            callback: function callback($$v) {
              _vm.$set(_vm.form_verification, "seaferer_code_verification", $$v);
            },
            expression: "\n                                      form_verification.seaferer_code_verification\n                                    "
          }
        }), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" File Type * : "), _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")])], 1)], 1)], 1)]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Verification By")])])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('b-form-group', [_c('b-form-input', {
          attrs: {
            "type": "text",
            "name": "verification_by",
            "placeholder": "verification by....",
            "required": ""
          },
          model: {
            value: _vm.form_verification.verification_by,
            callback: function callback($$v) {
              _vm.$set(_vm.form_verification, "verification_by", $$v);
            },
            expression: "\n                                      form_verification.verification_by\n                                    "
          }
        })], 1)], 1)])], 2)])])], 1), _vm.loading ? _c('div', {
          staticClass: "d-flex justify-content-center w-100 my-2"
        }, [_c('span', {
          staticClass: "spinner-border spinner-border-lg"
        })]) : _vm._e(), _c('b-row', [_c('b-col', {
          attrs: {
            "md": '6'
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "secondary",
            "block": ""
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('verification_document');
            }
          }
        }, [_vm._v("Close")])], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "block": "",
            "type": "submit",
            "disabled": _vm.saving
          }
        }, [!_vm.saving ? _c('i', {
          staticClass: "fa fa-file-signature"
        }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.saving ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _vm._e()])], 1)], 1)], 1)]), _c('b-modal', {
          attrs: {
            "id": "induction",
            "size": "md",
            "title": "Induction Checklist",
            "cancel-title": "Close",
            "hide-footer": ""
          }
        }, [_c('form', {
          attrs: {
            "action": "#",
            "method": "post"
          },
          on: {
            "submit": _vm.onSaveInduction
          }
        }, [_vm._l(_vm.department_form, function (state, index) {
          return _c('b-row', {
            key: index
          }, [_c('b-col', {
            attrs: {
              "md": "12"
            }
          }, [_c('b-card', {
            staticClass: "mb-1",
            attrs: {
              "no-body": ""
            }
          }, [_c('b-card-header', {
            staticClass: "p-1",
            attrs: {
              "header-tag": "header",
              "role": "tab"
            }
          }, [_c('b-button', {
            directives: [{
              name: "b-toggle",
              rawName: "v-b-toggle",
              value: "accordion-" + index,
              expression: "`accordion-` + index"
            }],
            class: "".concat((state === null || state === void 0 ? void 0 : state.checked) && "justify-content-between d-flex align-items-center"),
            attrs: {
              "disabled": state !== null && state !== void 0 && state.checked || state.department_id !== _vm.profile_department && _vm.profile_department !== null ? true : false,
              "block": "",
              "variant": "".concat(state !== null && state !== void 0 && state.checked ? 'success' : 'info')
            }
          }, [_c('span', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.name))]), state !== null && state !== void 0 && state.checked ? _c('i', {
            staticClass: "fas fa-check"
          }) : _vm._e()])], 1), _c('b-collapse', {
            attrs: {
              "id": "accordion-" + index,
              "visible": false,
              "accordion": "my-accordion",
              "role": "tabpanel"
            }
          }, [_c('b-card-body', [_c('b-form-group', {
            attrs: {
              "label": "Induksi Oleh",
              "label-for": "induction_by"
            }
          }, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: state.induction_by,
              expression: "state.induction_by"
            }],
            staticClass: "form-control",
            attrs: {
              "type": "text",
              "id": "induction_by"
            },
            domProps: {
              "value": state.induction_by
            },
            on: {
              "input": function input($event) {
                if ($event.target.composing) return;
                _vm.$set(state, "induction_by", $event.target.value);
              }
            }
          })]), _c('b-form-group', {
            attrs: {
              "label": "Tanggal Induksi",
              "label-for": "induction_date"
            }
          }, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: state.induction_date,
              expression: "state.induction_date"
            }],
            staticClass: "form-control",
            attrs: {
              "type": "date",
              "id": "induction_date"
            },
            domProps: {
              "value": state.induction_date
            },
            on: {
              "input": function input($event) {
                if ($event.target.composing) return;
                _vm.$set(state, "induction_date", $event.target.value);
              }
            }
          })]), _c('b-form-group', {
            attrs: {
              "label": "Attachment",
              "label-for": "attachment"
            }
          }, [_c('div', {
            staticClass: "custom-file"
          }, [_c('input', {
            staticClass: "custom-file-input",
            attrs: {
              "type": "file",
              "id": "validatedCustomFile",
              "accept": "image/*,application/*"
            },
            on: {
              "change": function change(event) {
                return _vm.prefiewFilesInduction(event, state);
              }
            }
          }), !state.attachment ? _c('label', {
            staticClass: "custom-file-label",
            attrs: {
              "for": "validatedCustomFile"
            }
          }, [_vm._v("Browse file...")]) : _c('label', {
            staticClass: "custom-file-label",
            attrs: {
              "for": "validatedCustomFile"
            }
          }, [_vm._v(_vm._s(state.attachment_label))])])]), _c('b-form-group', {
            attrs: {
              "label": "Notes",
              "label-for": "notes"
            }
          }, [_c('b-form-textarea', {
            attrs: {
              "id": "notes",
              "name": "notes",
              "rows": "3"
            },
            model: {
              value: state.notes,
              callback: function callback($$v) {
                _vm.$set(state, "notes", $$v);
              },
              expression: "state.notes"
            }
          })], 1)], 1)], 1)], 1)], 1)], 1);
        }), _vm.loading ? _c('div', {
          staticClass: "d-flex justify-content-center w-100 mt-3"
        }, [_c('span', {
          staticClass: "spinner-border spinner-border-lg"
        })]) : _vm._e(), _c('b-row', {
          staticClass: "mt-3"
        }, [_c('b-col', {
          attrs: {
            "md": '6'
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "secondary",
            "block": ""
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('induction');
            }
          }
        }, [_vm._v("Close")])], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "block": "",
            "type": "submit",
            "disabled": _vm.saving
          }
        }, [!_vm.saving ? _c('i', {
          staticClass: "fa fa-file-signature"
        }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.saving ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _vm._e()])], 1)], 1)], 2)]), _c('b-modal', {
          attrs: {
            "id": "medical-checkup",
            "size": "md",
            "title": "Medical Checkup",
            "cancel-title": "Close",
            "hide-footer": ""
          }
        }, [_c('ContentMedicalCheckup', {
          attrs: {
            "apiAction": 'medicalCheckup',
            "candidateId": (_vm$candidateProfile = _vm.candidateProfile) === null || _vm$candidateProfile === void 0 ? void 0 : _vm$candidateProfile.id,
            "getProfileCrew": _vm.filterCandidateList
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 3830525152)
  })] : _vm._e(), _vm.dashboard == 'BLACKLIST' ? [_c('TabBlacklist', {
    attrs: {
      "optionsPosition": _vm.optionsPosition
    }
  })] : _vm._e(), _c('b-sidebar', {
    ref: "formSignOn",
    attrs: {
      "id": "sign-on",
      "title": "SIGN ON CANDIDATE",
      "width": "90%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _vm$candidateProfile$, _vm$candidateProfile4, _vm$candidateProfile5, _vm$candidateProfile$2, _vm$candidateProfile6, _vm$candidateProfile7, _vm$candidateProfile$3, _vm$candidateProfile8, _vm$candidateProfile9, _vm$candidateProfile0, _vm$candidateProfile$4, _vm$candidateProfile1, _vm$candidateProfile10, _vm$candidateProfile$5, _vm$candidateProfile11, _vm$candidateProfile12, _vm$candidateProfile$6, _vm$candidateProfile13, _vm$candidateProfile14, _vm$form_signon, _vm$form_signon$attac;
        var hide = _ref.hide;
        return [_c('form', {
          attrs: {
            "action": "#",
            "method": "post"
          },
          on: {
            "submit": _vm.onSignOnSave
          }
        }, [_c('b-row', {
          staticClass: "m-3"
        }, [_c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "12"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click() {
              var _vm$candidateProfile2, _vm$candidateProfile3;
              return _vm.handleDownloadPKL((_vm$candidateProfile2 = _vm.candidateProfile) === null || _vm$candidateProfile2 === void 0 ? void 0 : _vm$candidateProfile2.id, (_vm$candidateProfile3 = _vm.candidateProfile) === null || _vm$candidateProfile3 === void 0 ? void 0 : _vm$candidateProfile3.nama_lengkap);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        }), _vm._v(" DOWNLOAD DOCUMENT CONTRACT")])], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_vm.currentStep === 0 ? _c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_vm._v("  "), _c('legend', {
          staticClass: "w-auto px-2",
          staticStyle: {
            "font-size": "14pt"
          }
        }, [_vm._v("Informasi Crew")]), _c('b-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "nama_crew",
            "for": "nama_crew"
          }
        }, [_c('strong', [_vm._v("Nama Crew")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$candidateProfile$ = (_vm$candidateProfile4 = _vm.candidateProfile) === null || _vm$candidateProfile4 === void 0 ? void 0 : (_vm$candidateProfile5 = _vm$candidateProfile4.personal_data) === null || _vm$candidateProfile5 === void 0 ? void 0 : _vm$candidateProfile5.full_name) !== null && _vm$candidateProfile$ !== void 0 ? _vm$candidateProfile$ : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "nik",
            "for": "nik"
          }
        }, [_c('strong', [_vm._v("NIK")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$candidateProfile$2 = (_vm$candidateProfile6 = _vm.candidateProfile) === null || _vm$candidateProfile6 === void 0 ? void 0 : (_vm$candidateProfile7 = _vm$candidateProfile6.personal_data) === null || _vm$candidateProfile7 === void 0 ? void 0 : _vm$candidateProfile7.nik_ktp) !== null && _vm$candidateProfile$2 !== void 0 ? _vm$candidateProfile$2 : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "jabatan",
            "for": "jabatan"
          }
        }, [_c('strong', [_vm._v("Jabatan")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$candidateProfile$3 = (_vm$candidateProfile8 = _vm.candidateProfile) === null || _vm$candidateProfile8 === void 0 ? void 0 : (_vm$candidateProfile9 = _vm$candidateProfile8.personal_data) === null || _vm$candidateProfile9 === void 0 ? void 0 : (_vm$candidateProfile0 = _vm$candidateProfile9.position) === null || _vm$candidateProfile0 === void 0 ? void 0 : _vm$candidateProfile0.name) !== null && _vm$candidateProfile$3 !== void 0 ? _vm$candidateProfile$3 : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "seaman_book",
            "for": "seaman_book"
          }
        }, [_c('strong', [_vm._v("Seaman Book")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$candidateProfile$4 = (_vm$candidateProfile1 = _vm.candidateProfile) === null || _vm$candidateProfile1 === void 0 ? void 0 : (_vm$candidateProfile10 = _vm$candidateProfile1.personal_data) === null || _vm$candidateProfile10 === void 0 ? void 0 : _vm$candidateProfile10.seaman_book_number) !== null && _vm$candidateProfile$4 !== void 0 ? _vm$candidateProfile$4 : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "seafarer_code",
            "for": "seafarer_code"
          }
        }, [_c('strong', [_vm._v("Seaferer Code")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$candidateProfile$5 = (_vm$candidateProfile11 = _vm.candidateProfile) === null || _vm$candidateProfile11 === void 0 ? void 0 : (_vm$candidateProfile12 = _vm$candidateProfile11.personal_data) === null || _vm$candidateProfile12 === void 0 ? void 0 : _vm$candidateProfile12.seaferer_code) !== null && _vm$candidateProfile$5 !== void 0 ? _vm$candidateProfile$5 : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "passport_number",
            "for": "passport_number"
          }
        }, [_c('strong', [_vm._v("Passport Number")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$candidateProfile$6 = (_vm$candidateProfile13 = _vm.candidateProfile) === null || _vm$candidateProfile13 === void 0 ? void 0 : (_vm$candidateProfile14 = _vm$candidateProfile13.personal_data) === null || _vm$candidateProfile14 === void 0 ? void 0 : _vm$candidateProfile14.passport_number) !== null && _vm$candidateProfile$6 !== void 0 ? _vm$candidateProfile$6 : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "file_contract",
            "for": "file_contract"
          }
        }, [_c('strong', [_vm._v("Attachment File")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-group', {
          attrs: {
            "label-for": "attachment"
          }
        }, [_c('b-form-file', {
          attrs: {
            "id": "attachment",
            "accept": "image/*,application/*"
          },
          model: {
            value: _vm.form_signon.attachment,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "attachment", $$v);
            },
            expression: "form_signon.attachment"
          }
        }), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" File Type * : "), _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")])], 1)], 1), _c('b-form-text', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s((_vm$form_signon = _vm.form_signon) === null || _vm$form_signon === void 0 ? void 0 : (_vm$form_signon$attac = _vm$form_signon.attachment) === null || _vm$form_signon$attac === void 0 ? void 0 : _vm$form_signon$attac.name) + " ")])], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "file_contract",
            "for": "file_contract"
          }
        }, [_c('strong', [_vm._v("Notes")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-textarea', {
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "id": "join_onboard",
            "placeholder": "notes...",
            "required": ""
          },
          model: {
            value: _vm.form_signon.remarks,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "remarks", $$v);
            },
            expression: "form_signon.remarks"
          }
        })], 1)])]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "perusahaan",
            "for": "perusahaan"
          }
        }, [_c('strong', [_vm._v("Perusahaan")])]), _c('b-form-group', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsCompanies,
            "size": "lg",
            "required": ""
          },
          on: {
            "change": _vm.setBpjs
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Perusahaan")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.form_signon.company_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "company_id", $$v);
            },
            expression: "form_signon.company_id"
          }
        })], 1)], 1), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "Jabatan",
            "for": "jabatan"
          }
        }, [_c('strong', [_vm._v("Jabatan")])]), _c('b-form-group', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsPosition,
            "size": "lg",
            "required": ""
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Jabatan")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.form_signon.position_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "position_id", $$v);
            },
            expression: "form_signon.position_id"
          }
        })], 1)], 1), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "nama_kapal",
            "for": "nama_kapal"
          }
        }, [_c('strong', [_vm._v("Nama Kapal")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.fleetOptions,
            "reduce": function reduce(fleetOptions) {
              return fleetOptions.value;
            },
            "placeholder": "Pilih Kapal",
            "required": ""
          },
          model: {
            value: _vm.form_signon.vehicle_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "vehicle_id", $$v);
            },
            expression: "form_signon.vehicle_id"
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "nama_kapal",
            "for": "nama_kapal"
          }
        }, [_c('strong', [_vm._v("Work Area")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsWorkArea,
            "size": "lg",
            "required": ""
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Work Area")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.form_signon.work_area_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "work_area_id", $$v);
            },
            expression: "form_signon.work_area_id"
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "pelabuhan",
            "for": "pelabuhan"
          }
        }, [_c('strong', [_vm._v("Pelabuhan")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form_signon.port_id,
            expression: "form_signon.port_id"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "id": "pelabuhan",
            "placeholder": "Pelabuhan...",
            "required": ""
          },
          domProps: {
            "value": _vm.form_signon.port_id
          },
          on: {
            "input": function input($event) {
              if ($event.target.composing) return;
              _vm.$set(_vm.form_signon, "port_id", $event.target.value);
            }
          }
        })])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "sign_on",
            "for": "sign_on"
          }
        }, [_c('strong', [_vm._v("Sign PKL")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-input', {
          attrs: {
            "type": "date",
            "id": "sign_on",
            "required": ""
          },
          model: {
            value: _vm.form_signon.sign_on,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "sign_on", $$v);
            },
            expression: "form_signon.sign_on"
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show")])], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "join_onboard",
            "for": "join_onboard"
          }
        }, [_c('strong', [_vm._v("Join Onboard")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-input', {
          attrs: {
            "type": "datetime-local",
            "id": "join_onboard",
            "required": ""
          },
          model: {
            value: _vm.form_signon.join_on_board,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "join_on_board", $$v);
            },
            expression: "form_signon.join_on_board"
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show")])], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "sign_off",
            "for": "sign_off"
          }
        }, [_c('strong', [_vm._v("Sign Off / Turun Kapal")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-input', {
          attrs: {
            "type": "datetime-local",
            "id": "sign_off"
          },
          model: {
            value: _vm.form_signon.sign_off,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "sign_off", $$v);
            },
            expression: "form_signon.sign_off"
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show")])], 1)])])], 1)], 1) : _vm._e(), _vm.currentStep === 1 ? _c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_c('legend', {
          staticClass: "w-auto px-2",
          staticStyle: {
            "font-size": "14pt"
          }
        }, [_vm._v("Payroll Component")]), _c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "basic_sallary",
            "for": "basic_sallary"
          }
        }, [_c('strong', [_vm._v("Sallary")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('div', {
          staticClass: "input-group"
        }, [_c('div', {
          staticClass: "input-group-prepend"
        }, [_c('span', {
          staticClass: "input-group-text bg-primary",
          attrs: {
            "id": "rp"
          }
        }, [_vm._v("Rp.")])]), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form_signon.basic_sallary,
            expression: "form_signon.basic_sallary"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "name": "basic_sallary",
            "id": "basic_sallary",
            "required": ""
          },
          domProps: {
            "value": _vm.form_signon.basic_sallary
          },
          on: {
            "input": function input($event) {
              if ($event.target.composing) return;
              _vm.$set(_vm.form_signon, "basic_sallary", $event.target.value);
            }
          }
        })]), _c('b-form-text', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.form_signon.basic_sallary)) + " ")])], 1)])])], 1)], 1) : _vm._e(), _vm.currentStep === 2 ? _c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_c('legend', {
          staticClass: "w-auto px-2",
          staticStyle: {
            "font-size": "14pt"
          }
        }, [_vm._v("BPJS Setting")]), _c('b-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center w-100"
        }, [_c('legend', {
          staticStyle: {
            "font-size": "14pt"
          }
        }, [_vm._v("BPJS Ketenagakerjaan")]), _c('b-form-checkbox', {
          attrs: {
            "id": "bpjstk_config",
            "value": 1,
            "unchecked-value": 0
          },
          model: {
            value: _vm.form_signon.bpjstk,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "bpjstk", $$v);
            },
            expression: "form_signon.bpjstk"
          }
        })], 1), _vm.form_signon.bpjstk === 1 ? _c('div', [_c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          staticClass: "col-sm-12 px-2",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_c('strong', [_vm._v("Basis Penggali")])]), _c('div', {
          staticClass: "px-2 row"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsSetting,
            "size": "lg"
          },
          model: {
            value: _vm.form_signon.bpjstk_config,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "bpjstk_config", $$v);
            },
            expression: "form_signon.bpjstk_config"
          }
        })], 1), _vm.form_signon.bpjstk_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsGaji,
            "size": "lg"
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Gaji")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.form_signon.basispengali_bpjstk,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "basispengali_bpjstk", $$v);
            },
            expression: "form_signon.basispengali_bpjstk"
          }
        })], 1) : _vm._e()])]), _c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          staticClass: "col-sm-12 px-2",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_c('strong', [_vm._v("JHT Configuration")])]), _c('div', {
          staticClass: "px-2 row"
        }, [_c('div', {
          staticClass: "col-sm-12 mb-2"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsSetting,
            "size": "lg",
            "required": ""
          },
          model: {
            value: _vm.form_signon.jht_config,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jht_config", $$v);
            },
            expression: "form_signon.jht_config"
          }
        })], 1), _vm.form_signon.jht_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('label', {
          staticClass: "col-xs-12",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_vm._v("JHT (DITANGGUNG PERUSAHAAN)")]), _c('div', {
          staticClass: "input-group"
        }, [_c('b-form-input', {
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "id": "uang_lembur",
            "step": ".0001"
          },
          model: {
            value: _vm.form_signon.jht_company_set_value,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jht_company_set_value", $$v);
            },
            expression: "\n                                        form_signon.jht_company_set_value\n                                      "
          }
        }), _c('div', {
          staticClass: "input-group-prepend"
        }, [_c('span', {
          staticClass: "input-group-text bg-primary",
          attrs: {
            "id": "rp"
          }
        }, [_vm._v("%")])])], 1)]) : _vm._e(), _vm.form_signon.jht_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('label', {
          staticClass: "col-xs-12",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_vm._v("JHT (DITANGGUNG KARYAWAN)")]), _c('div', {
          staticClass: "input-group"
        }, [_c('b-form-input', {
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "id": "uang_lembur",
            "step": ".0001"
          },
          model: {
            value: _vm.form_signon.jht_employee_set_value,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jht_employee_set_value", $$v);
            },
            expression: "\n                                        form_signon.jht_employee_set_value\n                                      "
          }
        }), _c('div', {
          staticClass: "input-group-prepend"
        }, [_c('span', {
          staticClass: "input-group-text bg-primary",
          attrs: {
            "id": "rp"
          }
        }, [_vm._v("%")])])], 1)]) : _vm._e()])]), _c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          staticClass: "col-sm-12 px-2",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_c('strong', [_vm._v("JP Configuration")])]), _c('div', {
          staticClass: "px-2 row"
        }, [_c('div', {
          staticClass: "col-sm-12 mb-2"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsSetting,
            "size": "lg",
            "required": ""
          },
          model: {
            value: _vm.form_signon.jp_config,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jp_config", $$v);
            },
            expression: "form_signon.jp_config"
          }
        })], 1), _vm.form_signon.jp_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('label', {
          staticClass: "col-xs-12",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_vm._v("JP (DITANGGUNG PERUSAHAAN)")]), _c('div', {
          staticClass: "input-group"
        }, [_c('b-form-input', {
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "id": "uang_lembur",
            "step": ".0001"
          },
          model: {
            value: _vm.form_signon.jp_company_set_value,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jp_company_set_value", $$v);
            },
            expression: "\n                                        form_signon.jp_company_set_value\n                                      "
          }
        }), _c('div', {
          staticClass: "input-group-prepend"
        }, [_c('span', {
          staticClass: "input-group-text bg-primary",
          attrs: {
            "id": "rp"
          }
        }, [_vm._v("%")])])], 1)]) : _vm._e(), _vm.form_signon.jp_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('label', {
          staticClass: "col-xs-12",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_vm._v("JP (DITANGGUNG KARYAWAN)")]), _c('div', {
          staticClass: "input-group"
        }, [_c('b-form-input', {
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "id": "uang_lembur",
            "step": ".0001"
          },
          model: {
            value: _vm.form_signon.jp_employee_set_value,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jp_employee_set_value", $$v);
            },
            expression: "\n                                        form_signon.jp_employee_set_value\n                                      "
          }
        }), _c('div', {
          staticClass: "input-group-prepend"
        }, [_c('span', {
          staticClass: "input-group-text bg-primary",
          attrs: {
            "id": "rp"
          }
        }, [_vm._v("%")])])], 1)]) : _vm._e()])]), _c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          staticClass: "col-sm-12 px-2",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_c('strong', [_vm._v("JKM Configuration")])]), _c('div', {
          staticClass: "px-2 row"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsSetting,
            "size": "lg"
          },
          model: {
            value: _vm.form_signon.jkm_config,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jkm_config", $$v);
            },
            expression: "form_signon.jkm_config"
          }
        })], 1), _vm.form_signon.jkm_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('div', {
          staticClass: "input-group"
        }, [_c('b-form-input', {
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "id": "uang_lembur",
            "step": ".0001"
          },
          model: {
            value: _vm.form_signon.jkm_set_value,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jkm_set_value", $$v);
            },
            expression: "form_signon.jkm_set_value"
          }
        }), _c('div', {
          staticClass: "input-group-prepend"
        }, [_c('span', {
          staticClass: "input-group-text bg-primary",
          attrs: {
            "id": "rp"
          }
        }, [_vm._v("%")])])], 1)]) : _vm._e()])]), _c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          staticClass: "col-sm-12 px-2",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_c('strong', [_vm._v("JKK Configuration")])]), _c('div', {
          staticClass: "px-2 row"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsSetting,
            "size": "lg"
          },
          model: {
            value: _vm.form_signon.jkk_config,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jkk_config", $$v);
            },
            expression: "form_signon.jkk_config"
          }
        })], 1), _vm.form_signon.jkk_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('div', {
          staticClass: "input-group"
        }, [_c('b-form-input', {
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "id": "uang_lembur",
            "step": ".0001"
          },
          model: {
            value: _vm.form_signon.jkk_set_value,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "jkk_set_value", $$v);
            },
            expression: "form_signon.jkk_set_value"
          }
        }), _c('div', {
          staticClass: "input-group-prepend"
        }, [_c('span', {
          staticClass: "input-group-text bg-primary",
          attrs: {
            "id": "rp"
          }
        }, [_vm._v("%")])])], 1)]) : _vm._e()])])]) : _vm._e()]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center w-100"
        }, [_c('legend', {
          staticStyle: {
            "font-size": "14pt"
          }
        }, [_vm._v("BPJS Kesehatan")]), _c('b-form-checkbox', {
          attrs: {
            "id": "bpjsksh_config",
            "value": 1,
            "unchecked-value": 0
          },
          model: {
            value: _vm.form_signon.bpjsksh,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "bpjsksh", $$v);
            },
            expression: "form_signon.bpjsksh"
          }
        })], 1), _vm.form_signon.bpjsksh === 1 ? _c('div', [_c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          staticClass: "col-sm-12 px-2",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_c('strong', [_vm._v("Basis Penggali")])]), _c('div', {
          staticClass: "px-2 row"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsSetting,
            "size": "lg"
          },
          model: {
            value: _vm.form_signon.basispengali_bpjsksh_config,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "basispengali_bpjsksh_config", $$v);
            },
            expression: "\n                                      form_signon.basispengali_bpjsksh_config\n                                    "
          }
        })], 1), _vm.form_signon.basispengali_bpjsksh_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsGaji,
            "size": "lg"
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Gaji")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.form_signon.basispengali_bpjsksh,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "basispengali_bpjsksh", $$v);
            },
            expression: "form_signon.basispengali_bpjsksh"
          }
        })], 1) : _vm._e()])]), _c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          staticClass: "col-sm-12 px-2",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_c('strong', [_vm._v("BPJS Configuration")])]), _c('div', {
          staticClass: "px-2 row"
        }, [_c('div', {
          staticClass: "col-sm-12 mb-2"
        }, [_c('b-form-select', {
          staticClass: "col-md-12",
          attrs: {
            "plain": "",
            "options": _vm.optionsSetting,
            "size": "lg",
            "required": ""
          },
          model: {
            value: _vm.form_signon.bpjsksh_config,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "bpjsksh_config", $$v);
            },
            expression: "form_signon.bpjsksh_config"
          }
        })], 1), _vm.form_signon.bpjsksh_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('label', {
          staticClass: "col-xs-12",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_vm._v("BPJS KSH (DITANGGUNG PERUSAHAAN)")]), _c('div', {
          staticClass: "input-group"
        }, [_c('b-form-input', {
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "id": "uang_lembur",
            "step": ".0001"
          },
          model: {
            value: _vm.form_signon.bpjsksh_company_set_value,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "bpjsksh_company_set_value", $$v);
            },
            expression: "\n                                        form_signon.bpjsksh_company_set_value\n                                      "
          }
        }), _c('div', {
          staticClass: "input-group-prepend"
        }, [_c('span', {
          staticClass: "input-group-text bg-primary",
          attrs: {
            "id": "rp"
          }
        }, [_vm._v("%")])])], 1)]) : _vm._e(), _vm.form_signon.bpjsksh_config === 1 ? _c('div', {
          staticClass: "col-sm-6"
        }, [_c('label', {
          staticClass: "col-xs-12",
          attrs: {
            "label": "gaji_pokok",
            "for": "gaji_pokok"
          }
        }, [_vm._v("BPJS KSH (DITANGGUNG KARYAWAN)")]), _c('div', {
          staticClass: "input-group"
        }, [_c('b-form-input', {
          staticClass: "form-control",
          attrs: {
            "type": "number",
            "id": "uang_lembur",
            "step": ".0001"
          },
          model: {
            value: _vm.form_signon.bpjsksh_employee_set_value,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signon, "bpjsksh_employee_set_value", $$v);
            },
            expression: "\n                                        form_signon.bpjsksh_employee_set_value\n                                      "
          }
        }), _c('div', {
          staticClass: "input-group-prepend"
        }, [_c('span', {
          staticClass: "input-group-text bg-primary",
          attrs: {
            "id": "rp"
          }
        }, [_vm._v("%")])])], 1)]) : _vm._e()])])]) : _vm._e()])], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "".concat(_vm.currentStep === 0 ? 'secondary' : 'primary'),
            "disabled": _vm.currentStep === 0,
            "block": "",
            "type": "button"
          },
          on: {
            "click": _vm.prevStep
          }
        }, [_c('i', {
          staticClass: "fa fa-chevron-left"
        }), _vm._v(" PREVIOUS FORM ")])], 1), _vm.currentStep !== 2 ? _c('b-col', {
          attrs: {
            "md": "8"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "block": "",
            "type": "submit"
          }
        }, [_vm._v(" NEXT FORM "), _c('i', {
          staticClass: "fa fa-chevron-right"
        })])], 1) : _vm._e(), _vm.currentStep === 2 ? _c('b-col', {
          attrs: {
            "md": "8"
          }
        }, [_c('b-button', {
          attrs: {
            "disabled": _vm.saving,
            "variant": "primary",
            "block": "",
            "type": "submit"
          }
        }, [_vm.saving ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _vm._e(), !_vm.saving ? _c('i', {
          staticClass: "fa fa-file-signature"
        }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("SUBMIT")]) : _vm._e()])], 1) : _vm._e()], 1)], 1)], 1)], 1)];
      }
    }])
  }), _c('b-sidebar', {
    attrs: {
      "id": "swap-position",
      "title": "SWAP POSITION",
      "width": "50%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var hide = _ref2.hide;
        return [_c('form', {
          attrs: {
            "action": "#",
            "method": "post"
          },
          on: {
            "submit": _vm.onSaveSwapPosition
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-card', {
          staticClass: "mb-1",
          attrs: {
            "no-body": ""
          }
        }, [_c('b-card-body', [_c('b-row', [_c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Vehicles",
            "label-for": "vehicle_id"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.fleetOptions,
            "reduce": function reduce(fleetOptions) {
              return fleetOptions.value;
            },
            "placeholder": "Select Type of Vehicle",
            "required": ""
          },
          model: {
            value: _vm.swap_position.vehicle_id,
            callback: function callback($$v) {
              _vm.$set(_vm.swap_position, "vehicle_id", $$v);
            },
            expression: "swap_position.vehicle_id"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Join Company",
            "label-for": "start_date"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "datetime-local",
            "id": "start_date",
            "required": ""
          },
          model: {
            value: _vm.swap_position.start_date,
            callback: function callback($$v) {
              _vm.$set(_vm.swap_position, "start_date", $$v);
            },
            expression: "swap_position.start_date"
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show ")])], 1)], 1), _c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Join on Board/Sign On",
            "label-for": "join_on_board"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "datetime-local",
            "id": "join_on_board",
            "required": ""
          },
          model: {
            value: _vm.swap_position.join_on_board,
            callback: function callback($$v) {
              _vm.$set(_vm.swap_position, "join_on_board", $$v);
            },
            expression: "swap_position.join_on_board"
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show ")])], 1)], 1), _c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Position/Jabatan",
            "label-for": "position_id"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.optionsPosition,
            "reduce": function reduce(optionsPosition) {
              return optionsPosition.value;
            },
            "placeholder": "Select Position",
            "required": ""
          },
          model: {
            value: _vm.swap_position.position_id,
            callback: function callback($$v) {
              _vm.$set(_vm.swap_position, "position_id", $$v);
            },
            expression: "swap_position.position_id"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Company",
            "label-for": "company_id"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "size": "sm",
            "options": _vm.optionsCompanies
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": ''
                }
              }, [_vm._v("Select Company")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.swap_position.company_id,
            callback: function callback($$v) {
              _vm.$set(_vm.swap_position, "company_id", $$v);
            },
            expression: "swap_position.company_id"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Port",
            "label-for": "port_id"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.optionsPorts,
            "reduce": function reduce(optionsPorts) {
              return optionsPorts.value;
            },
            "placeholder": "Select port...",
            "required": ""
          },
          model: {
            value: _vm.swap_position.port_id,
            callback: function callback($$v) {
              _vm.$set(_vm.swap_position, "port_id", $$v);
            },
            expression: "swap_position.port_id"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Attachment",
            "label-for": "attachment"
          }
        }, [_c('div', {
          staticClass: "custom-file"
        }, [_c('input', {
          staticClass: "custom-file-input",
          attrs: {
            "type": "file",
            "id": "validatedCustomFile",
            "accept": "application/*,image/png,image/jpeg,image/jpg"
          },
          on: {
            "change": function change(event) {
              return _vm.prefiewFiles(event, _vm.swap_position);
            }
          }
        }), !_vm.swap_position.file ? _c('label', {
          staticClass: "custom-file-label",
          attrs: {
            "for": "validatedCustomFile"
          }
        }, [_vm._v("Browse file...")]) : _c('label', {
          staticClass: "custom-file-label",
          attrs: {
            "for": "validatedCustomFile"
          }
        }, [_vm._v(_vm._s(_vm.swap_position.file_label))])]), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" File Type * : "), _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("10 MB / File")])], 1)])], 1), _c('b-col', {
          attrs: {
            "lg": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "type": "textarea",
            "label": "Notes",
            "label-for": "remarks"
          }
        }, [_c('b-form-textarea', {
          staticClass: "form-control",
          attrs: {
            "id": "remarks",
            "name": "remarks",
            "rows": "3"
          },
          model: {
            value: _vm.swap_position.remarks,
            callback: function callback($$v) {
              _vm.$set(_vm.swap_position, "remarks", $$v);
            },
            expression: "swap_position.remarks"
          }
        })], 1)], 1)], 1)], 1)], 1)], 1), _c('b-col', {
          staticClass: "p-4",
          attrs: {
            "md": "12"
          }
        }, [_c('b-row', {
          staticClass: "mt-3"
        }, [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "secondary",
            "block": ""
          },
          on: {
            "click": _vm.hideModal
          }
        }, [_vm._v("Close")])], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "block": "",
            "type": "submit",
            "disabled": _vm.saving
          }
        }, [!_vm.saving ? _c('i', {
          staticClass: "fa fa-edit"
        }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.saving ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _vm._e()])], 1)], 1)], 1)], 1)], 1)];
      }
    }])
  }), _c('b-sidebar', {
    attrs: {
      "id": "sign-off",
      "title": "SIGN OFF CREW",
      "width": "50%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var _vm$crewProfile$fulln, _vm$crewProfile, _vm$crewProfile$no_kt, _vm$crewProfile2, _vm$crewProfile$posit, _vm$crewProfile3, _vm$crewProfile3$posi, _vm$crewProfile$perso, _vm$crewProfile4, _vm$crewProfile4$pers, _vm$crewProfile$perso2, _vm$crewProfile5, _vm$crewProfile5$pers, _vm$crewProfile$perso3, _vm$crewProfile6, _vm$crewProfile6$pers, _vm$crewProfile$compa, _vm$crewProfile7, _vm$crewProfile7$comp, _vm$crewProfile$vehic, _vm$crewProfile8, _vm$crewProfile8$vehi, _vm$crewProfile$port$, _vm$crewProfile9, _vm$crewProfile9$port, _vm$crewProfile0, _vm$crewProfile1, _vm$crewProfile10, _vm$crewProfile11, _vm$master_signoff_re;
        var hide = _ref3.hide;
        return [_c('form', {
          attrs: {
            "action": "#",
            "method": "post"
          },
          on: {
            "submit": _vm.onSaveSignOffCrew
          }
        }, [_c('b-row', {
          staticClass: "m-3"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_c('legend', {
          staticClass: "w-auto px-2",
          staticStyle: {
            "font-size": "14pt"
          }
        }, [_vm._v("Informasi Crew")]), _c('b-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "nama_crew",
            "for": "nama_crew"
          }
        }, [_c('strong', [_vm._v("Nama Crew")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile$fulln = (_vm$crewProfile = _vm.crewProfile) === null || _vm$crewProfile === void 0 ? void 0 : _vm$crewProfile.fullname) !== null && _vm$crewProfile$fulln !== void 0 ? _vm$crewProfile$fulln : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "nik",
            "for": "nik"
          }
        }, [_c('strong', [_vm._v("NIK")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile$no_kt = (_vm$crewProfile2 = _vm.crewProfile) === null || _vm$crewProfile2 === void 0 ? void 0 : _vm$crewProfile2.no_ktp) !== null && _vm$crewProfile$no_kt !== void 0 ? _vm$crewProfile$no_kt : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "jabatan",
            "for": "jabatan"
          }
        }, [_c('strong', [_vm._v("Jabatan")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile$posit = (_vm$crewProfile3 = _vm.crewProfile) === null || _vm$crewProfile3 === void 0 ? void 0 : (_vm$crewProfile3$posi = _vm$crewProfile3.position) === null || _vm$crewProfile3$posi === void 0 ? void 0 : _vm$crewProfile3$posi.name) !== null && _vm$crewProfile$posit !== void 0 ? _vm$crewProfile$posit : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "seaman_book",
            "for": "seaman_book"
          }
        }, [_c('strong', [_vm._v("Seaman Book")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile$perso = (_vm$crewProfile4 = _vm.crewProfile) === null || _vm$crewProfile4 === void 0 ? void 0 : (_vm$crewProfile4$pers = _vm$crewProfile4.personal_data) === null || _vm$crewProfile4$pers === void 0 ? void 0 : _vm$crewProfile4$pers.seaman_book_number) !== null && _vm$crewProfile$perso !== void 0 ? _vm$crewProfile$perso : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "seafarer_code",
            "for": "seafarer_code"
          }
        }, [_c('strong', [_vm._v("Seafarer Code")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile$perso2 = (_vm$crewProfile5 = _vm.crewProfile) === null || _vm$crewProfile5 === void 0 ? void 0 : (_vm$crewProfile5$pers = _vm$crewProfile5.personal_data) === null || _vm$crewProfile5$pers === void 0 ? void 0 : _vm$crewProfile5$pers.seaferer_code) !== null && _vm$crewProfile$perso2 !== void 0 ? _vm$crewProfile$perso2 : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "passport_number",
            "for": "passport_number"
          }
        }, [_c('strong', [_vm._v("Passport Number")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile$perso3 = (_vm$crewProfile6 = _vm.crewProfile) === null || _vm$crewProfile6 === void 0 ? void 0 : (_vm$crewProfile6$pers = _vm$crewProfile6.personal_data) === null || _vm$crewProfile6$pers === void 0 ? void 0 : _vm$crewProfile6$pers.passport_number) !== null && _vm$crewProfile$perso3 !== void 0 ? _vm$crewProfile$perso3 : '-') + " ")])])]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "perusahaan",
            "for": "perusahaan"
          }
        }, [_c('strong', [_vm._v("Perusahaan")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile$compa = (_vm$crewProfile7 = _vm.crewProfile) === null || _vm$crewProfile7 === void 0 ? void 0 : (_vm$crewProfile7$comp = _vm$crewProfile7.company) === null || _vm$crewProfile7$comp === void 0 ? void 0 : _vm$crewProfile7$comp.company) !== null && _vm$crewProfile$compa !== void 0 ? _vm$crewProfile$compa : '-'))])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "nama_kapal",
            "for": "nama_kapal"
          }
        }, [_c('strong', [_vm._v("Nama Kapal")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile$vehic = (_vm$crewProfile8 = _vm.crewProfile) === null || _vm$crewProfile8 === void 0 ? void 0 : (_vm$crewProfile8$vehi = _vm$crewProfile8.vehicle) === null || _vm$crewProfile8$vehi === void 0 ? void 0 : _vm$crewProfile8$vehi.name) !== null && _vm$crewProfile$vehic !== void 0 ? _vm$crewProfile$vehic : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "pelabuhan",
            "for": "pelabuhan"
          }
        }, [_c('strong', [_vm._v("Pelabuhan")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile$port$ = (_vm$crewProfile9 = _vm.crewProfile) === null || _vm$crewProfile9 === void 0 ? void 0 : (_vm$crewProfile9$port = _vm$crewProfile9.port) === null || _vm$crewProfile9$port === void 0 ? void 0 : _vm$crewProfile9$port.port_name) !== null && _vm$crewProfile$port$ !== void 0 ? _vm$crewProfile$port$ : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "naik_kapal",
            "for": "naik_kapal"
          }
        }, [_c('strong', [_vm._v("Join Company")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile0 = _vm.crewProfile) !== null && _vm$crewProfile0 !== void 0 && _vm$crewProfile0.join_on_board ? _vm.moment((_vm$crewProfile1 = _vm.crewProfile) === null || _vm$crewProfile1 === void 0 ? void 0 : _vm$crewProfile1.join_on_board).format('DD MMMM YYYY HH:mm') : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "naik_kapal",
            "for": "naik_kapal"
          }
        }, [_c('strong', [_vm._v("Join on Board/Sign On")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(" " + _vm._s((_vm$crewProfile10 = _vm.crewProfile) !== null && _vm$crewProfile10 !== void 0 && _vm$crewProfile10.sign_on ? _vm.moment((_vm$crewProfile11 = _vm.crewProfile) === null || _vm$crewProfile11 === void 0 ? void 0 : _vm$crewProfile11.sign_on).format('DD MMMM YYYY HH:mm') : '-') + " ")])]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "turun_kapal",
            "for": "turun_kapal"
          }
        }, [_c('strong', [_vm._v("Sign Off / Turun Kapal")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-input', {
          attrs: {
            "type": "datetime-local",
            "name": "sign_off",
            "required": ""
          },
          model: {
            value: _vm.form_signoff_crew.sign_off,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signoff_crew, "sign_off", $$v);
            },
            expression: "form_signoff_crew.sign_off"
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "turun_kapal",
            "for": "turun_kapal"
          }
        }, [_c('strong', [_vm._v("Status EMP Crewing")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.optionsEmployeeStatus,
            "size": "sm",
            "required": "",
            "name": "status_emp_crewing_id"
          },
          on: {
            "change": function change() {
              var _vm$optionsEmployeeSt, _vm$optionsEmployeeSt2;
              var empStatus = (_vm$optionsEmployeeSt = _vm.optionsEmployeeStatus) !== null && _vm$optionsEmployeeSt !== void 0 && (_vm$optionsEmployeeSt2 = _vm$optionsEmployeeSt.find(function (obj) {
                return (obj === null || obj === void 0 ? void 0 : obj.id) === _vm.form_signoff_crew.status_emp_crewing_id;
              })) !== null && _vm$optionsEmployeeSt2 !== void 0 && _vm$optionsEmployeeSt2.alias['blacklist'].includes(empStatus) ? _vm.master_signoff_reasons = _vm.master_signoff_reasons.map(function (val) {
                return Object.assign({}, val, {
                  disabled: val.alias === 'blacklist' ? false : true,
                  checked: val.alias === 'blacklist' ? true : false
                });
              }) : _vm.master_signoff_reasons = _vm.master_signoff_reasons.map(function (val) {
                return Object.assign({}, val, {
                  disabled: false,
                  checked: false
                });
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Select Status Crew")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.form_signoff_crew.status_emp_crewing_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signoff_crew, "status_emp_crewing_id", $$v);
            },
            expression: "\n                                  form_signoff_crew.status_emp_crewing_id\n                                "
          }
        })], 1)])])], 1)], 1), _c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_c('legend', {
          staticClass: "w-auto px-2",
          staticStyle: {
            "font-size": "14pt"
          }
        }, [_vm._v("Reason Sign Off")]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', {
          staticClass: "text-center"
        }, [_c('th', {
          attrs: {
            "width": "90%"
          }
        }, [_vm._v("DESKRIPSI")]), _c('th', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v("STATUS")])])]), _c('tbody', _vm._l(_vm.master_signoff_reasons, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('th', [_vm._v(" " + _vm._s(state.name))]), _c('td', {
            staticClass: "text-center"
          }, [[_c('b-form-checkbox', {
            staticClass: "ml-4",
            attrs: {
              "name": "check-button",
              "switch": "",
              "inline": "",
              "disabled": state.disabled
            },
            on: {
              "change": function change($event) {
                return _vm.selectStatusSignOffCrew(state, index);
              }
            },
            model: {
              value: state.checked,
              callback: function callback($$v) {
                _vm.$set(state, "checked", $$v);
              },
              expression: "state.checked"
            }
          })]], 2)]);
        }), 0)]), (_vm$master_signoff_re = _vm.master_signoff_reasons.find(function (reason) {
          return reason.alias === 'blacklist';
        })) !== null && _vm$master_signoff_re !== void 0 && _vm$master_signoff_re.checked ? _c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary"
        }, [_vm._v("Reason Black List")]), _c('b-form-group', [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.optionBlacklistReasons,
            "size": "lg",
            "aria-placeholder": "Pilih Alasan",
            "required": ""
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Alasan")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.form_signoff_crew.reason_blacklist_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signoff_crew, "reason_blacklist_id", $$v);
            },
            expression: "form_signoff_crew.reason_blacklist_id"
          }
        })], 1), _c('b-form-textarea', {
          attrs: {
            "rows": "3",
            "value": "Notes",
            "placeholder": "Notes..."
          },
          model: {
            value: _vm.form_signoff_crew.remarks,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signoff_crew, "remarks", $$v);
            },
            expression: "form_signoff_crew.remarks"
          }
        })], 1) : _c('b-form-textarea', {
          attrs: {
            "placeholder": "Notes...",
            "id": "remarks"
          },
          model: {
            value: _vm.form_signoff_crew.remarks,
            callback: function callback($$v) {
              _vm.$set(_vm.form_signoff_crew, "remarks", $$v);
            },
            expression: "form_signoff_crew.remarks"
          }
        })], 1), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "12"
          }
        }, [_c('span', [_c('b-button', {
          attrs: {
            "variant": "primary",
            "block": "",
            "type": "submit",
            "disabled": _vm.saving
          }
        }, [!_vm.saving ? _c('i', {
          staticClass: "fa fa-file-signature"
        }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.saving ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _vm._e()])], 1)])], 1)], 1)], 1)];
      }
    }])
  }), _c('b-sidebar', {
    attrs: {
      "id": "blacklist-crew",
      "title": "BLACK LIST",
      "width": "50%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var _vm$crewProfile$fulln2, _vm$crewProfile12, _vm$crewProfile$compa2, _vm$crewProfile13, _vm$crewProfile13$com, _vm$crewProfile$posit2, _vm$crewProfile14, _vm$crewProfile14$pos, _vm$crewProfile$port$2, _vm$crewProfile15, _vm$crewProfile15$por, _vm$crewProfile$perso4, _vm$crewProfile16, _vm$crewProfile16$per, _vm$crewProfile$vehic2, _vm$crewProfile17, _vm$crewProfile17$veh, _vm$crewProfile$nip, _vm$crewProfile18, _vm$crewProfile$sign_, _vm$crewProfile19, _vm$crewProfile$perso5, _vm$crewProfile20, _vm$crewProfile20$per, _vm$crewProfile$sign_2, _vm$crewProfile21, _vm$crewProfile$perso6, _vm$crewProfile22, _vm$crewProfile22$per, _vm$crewProfile$perso7, _vm$crewProfile23, _vm$crewProfile23$per, _vm$crewProfile$perso8, _vm$crewProfile24, _vm$crewProfile24$per, _vm$crewProfile$perso9, _vm$crewProfile25, _vm$crewProfile25$per, _vm$crewProfile$perso0, _vm$crewProfile26, _vm$crewProfile26$per, _vm$crewProfile$perso1, _vm$crewProfile27, _vm$crewProfile27$per, _vm$crewProfile$candi, _vm$crewProfile28, _vm$crewProfile28$can, _vm$crewProfile28$can2, _vm$crewProfile28$can3, _vm$candidateProfile$7, _vm$candidateProfile15, _vm$candidateProfile16, _vm$candidateProfile$8, _vm$candidateProfile17, _vm$candidateProfile18, _vm$candidateProfile19, _vm$candidateProfile20, _vm$candidateProfile21, _vm$candidateProfile$9, _vm$candidateProfile22, _vm$candidateProfile23, _vm$candidateProfile$0, _vm$candidateProfile24, _vm$candidateProfile25, _vm$candidateProfile$1, _vm$candidateProfile26, _vm$candidateProfile$10, _vm$candidateProfile27, _vm$candidateProfile28, _vm$candidateProfile$11, _vm$candidateProfile29, _vm$candidateProfile30, _vm$candidateProfile$12, _vm$candidateProfile31, _vm$candidateProfile32, _vm$candidateProfile$13, _vm$candidateProfile33, _vm$candidateProfile34, _vm$candidateProfile$14, _vm$candidateProfile35, _vm$candidateProfile36, _vm$candidateProfile37;
        var hide = _ref4.hide;
        return [_c('b-row', {
          staticClass: "m-3"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_vm.form_crew.key === 'crew' ? _c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary"
        }, [_vm._v("Informasi Crew")]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nama Crew")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$fulln2 = (_vm$crewProfile12 = _vm.crewProfile) === null || _vm$crewProfile12 === void 0 ? void 0 : _vm$crewProfile12.fullname) !== null && _vm$crewProfile$fulln2 !== void 0 ? _vm$crewProfile$fulln2 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Perusahaan")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$compa2 = (_vm$crewProfile13 = _vm.crewProfile) === null || _vm$crewProfile13 === void 0 ? void 0 : (_vm$crewProfile13$com = _vm$crewProfile13.company) === null || _vm$crewProfile13$com === void 0 ? void 0 : _vm$crewProfile13$com.company) !== null && _vm$crewProfile$compa2 !== void 0 ? _vm$crewProfile$compa2 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Jabatan")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$posit2 = (_vm$crewProfile14 = _vm.crewProfile) === null || _vm$crewProfile14 === void 0 ? void 0 : (_vm$crewProfile14$pos = _vm$crewProfile14.position) === null || _vm$crewProfile14$pos === void 0 ? void 0 : _vm$crewProfile14$pos.name) !== null && _vm$crewProfile$posit2 !== void 0 ? _vm$crewProfile$posit2 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Pelabuhan")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$port$2 = (_vm$crewProfile15 = _vm.crewProfile) === null || _vm$crewProfile15 === void 0 ? void 0 : (_vm$crewProfile15$por = _vm$crewProfile15.port) === null || _vm$crewProfile15$por === void 0 ? void 0 : _vm$crewProfile15$por.port_name) !== null && _vm$crewProfile$port$2 !== void 0 ? _vm$crewProfile$port$2 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("NIK")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$perso4 = (_vm$crewProfile16 = _vm.crewProfile) === null || _vm$crewProfile16 === void 0 ? void 0 : (_vm$crewProfile16$per = _vm$crewProfile16.personal_data) === null || _vm$crewProfile16$per === void 0 ? void 0 : _vm$crewProfile16$per.nik_ktp) !== null && _vm$crewProfile$perso4 !== void 0 ? _vm$crewProfile$perso4 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nama Kapal")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$vehic2 = (_vm$crewProfile17 = _vm.crewProfile) === null || _vm$crewProfile17 === void 0 ? void 0 : (_vm$crewProfile17$veh = _vm$crewProfile17.vehicle) === null || _vm$crewProfile17$veh === void 0 ? void 0 : _vm$crewProfile17$veh.name) !== null && _vm$crewProfile$vehic2 !== void 0 ? _vm$crewProfile$vehic2 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nomor Pegawai")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$nip = (_vm$crewProfile18 = _vm.crewProfile) === null || _vm$crewProfile18 === void 0 ? void 0 : _vm$crewProfile18.nip) !== null && _vm$crewProfile$nip !== void 0 ? _vm$crewProfile$nip : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Sign On")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$sign_ = (_vm$crewProfile19 = _vm.crewProfile) === null || _vm$crewProfile19 === void 0 ? void 0 : _vm$crewProfile19.sign_on) !== null && _vm$crewProfile$sign_ !== void 0 ? _vm$crewProfile$sign_ : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Seaferer Code")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$perso5 = (_vm$crewProfile20 = _vm.crewProfile) === null || _vm$crewProfile20 === void 0 ? void 0 : (_vm$crewProfile20$per = _vm$crewProfile20.personal_data) === null || _vm$crewProfile20$per === void 0 ? void 0 : _vm$crewProfile20$per.seaferer_code) !== null && _vm$crewProfile$perso5 !== void 0 ? _vm$crewProfile$perso5 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Sign Off")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$sign_2 = (_vm$crewProfile21 = _vm.crewProfile) === null || _vm$crewProfile21 === void 0 ? void 0 : _vm$crewProfile21.sign_off) !== null && _vm$crewProfile$sign_2 !== void 0 ? _vm$crewProfile$sign_2 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nomor NPWP")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$perso6 = (_vm$crewProfile22 = _vm.crewProfile) === null || _vm$crewProfile22 === void 0 ? void 0 : (_vm$crewProfile22$per = _vm$crewProfile22.personal_data) === null || _vm$crewProfile22$per === void 0 ? void 0 : _vm$crewProfile22$per.npwp_number) !== null && _vm$crewProfile$perso6 !== void 0 ? _vm$crewProfile$perso6 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("No. Tlp / Hp")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$perso7 = (_vm$crewProfile23 = _vm.crewProfile) === null || _vm$crewProfile23 === void 0 ? void 0 : (_vm$crewProfile23$per = _vm$crewProfile23.personal_data) === null || _vm$crewProfile23$per === void 0 ? void 0 : _vm$crewProfile23$per.hp_number) !== null && _vm$crewProfile$perso7 !== void 0 ? _vm$crewProfile$perso7 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nomor Passport")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$perso8 = (_vm$crewProfile24 = _vm.crewProfile) === null || _vm$crewProfile24 === void 0 ? void 0 : (_vm$crewProfile24$per = _vm$crewProfile24.personal_data) === null || _vm$crewProfile24$per === void 0 ? void 0 : _vm$crewProfile24$per.passport_number) !== null && _vm$crewProfile$perso8 !== void 0 ? _vm$crewProfile$perso8 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Email")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$perso9 = (_vm$crewProfile25 = _vm.crewProfile) === null || _vm$crewProfile25 === void 0 ? void 0 : (_vm$crewProfile25$per = _vm$crewProfile25.personal_data) === null || _vm$crewProfile25$per === void 0 ? void 0 : _vm$crewProfile25$per.email) !== null && _vm$crewProfile$perso9 !== void 0 ? _vm$crewProfile$perso9 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nomor Seamanbook")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$perso0 = (_vm$crewProfile26 = _vm.crewProfile) === null || _vm$crewProfile26 === void 0 ? void 0 : (_vm$crewProfile26$per = _vm$crewProfile26.personal_data) === null || _vm$crewProfile26$per === void 0 ? void 0 : _vm$crewProfile26$per.seaman_book_number) !== null && _vm$crewProfile$perso0 !== void 0 ? _vm$crewProfile$perso0 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Kewarganegaraan")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$perso1 = (_vm$crewProfile27 = _vm.crewProfile) === null || _vm$crewProfile27 === void 0 ? void 0 : (_vm$crewProfile27$per = _vm$crewProfile27.personal_data) === null || _vm$crewProfile27$per === void 0 ? void 0 : _vm$crewProfile27$per.citizenship) !== null && _vm$crewProfile$perso1 !== void 0 ? _vm$crewProfile$perso1 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Alamat")])]), _c('td', {
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v(_vm._s((_vm$crewProfile$candi = (_vm$crewProfile28 = _vm.crewProfile) === null || _vm$crewProfile28 === void 0 ? void 0 : (_vm$crewProfile28$can = _vm$crewProfile28.candidate) === null || _vm$crewProfile28$can === void 0 ? void 0 : (_vm$crewProfile28$can2 = _vm$crewProfile28$can.alamat_ktp) === null || _vm$crewProfile28$can2 === void 0 ? void 0 : (_vm$crewProfile28$can3 = _vm$crewProfile28$can2[0]) === null || _vm$crewProfile28$can3 === void 0 ? void 0 : _vm$crewProfile28$can3.alamat) !== null && _vm$crewProfile$candi !== void 0 ? _vm$crewProfile$candi : '-'))])])])])]) : _vm._e(), _vm.form_candidate.key === 'candidate' ? _c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary"
        }, [_vm._v("Informasi Candidate")]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nama Candidate")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$7 = (_vm$candidateProfile15 = _vm.candidateProfile) === null || _vm$candidateProfile15 === void 0 ? void 0 : (_vm$candidateProfile16 = _vm$candidateProfile15.personal_data) === null || _vm$candidateProfile16 === void 0 ? void 0 : _vm$candidateProfile16.full_name) !== null && _vm$candidateProfile$7 !== void 0 ? _vm$candidateProfile$7 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nomor Passport")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$8 = (_vm$candidateProfile17 = _vm.candidateProfile) === null || _vm$candidateProfile17 === void 0 ? void 0 : (_vm$candidateProfile18 = _vm$candidateProfile17.personal_data) === null || _vm$candidateProfile18 === void 0 ? void 0 : _vm$candidateProfile18.passport_number) !== null && _vm$candidateProfile$8 !== void 0 ? _vm$candidateProfile$8 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Jabatan")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile19 = _vm.candidateProfile) === null || _vm$candidateProfile19 === void 0 ? void 0 : (_vm$candidateProfile20 = _vm$candidateProfile19.personal_data) === null || _vm$candidateProfile20 === void 0 ? void 0 : (_vm$candidateProfile21 = _vm$candidateProfile20.position) === null || _vm$candidateProfile21 === void 0 ? void 0 : _vm$candidateProfile21.name))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nomor Seamanbook")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$9 = (_vm$candidateProfile22 = _vm.candidateProfile) === null || _vm$candidateProfile22 === void 0 ? void 0 : (_vm$candidateProfile23 = _vm$candidateProfile22.personal_data) === null || _vm$candidateProfile23 === void 0 ? void 0 : _vm$candidateProfile23.seaman_book_number) !== null && _vm$candidateProfile$9 !== void 0 ? _vm$candidateProfile$9 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("NIK")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$0 = (_vm$candidateProfile24 = _vm.candidateProfile) === null || _vm$candidateProfile24 === void 0 ? void 0 : (_vm$candidateProfile25 = _vm$candidateProfile24.personal_data) === null || _vm$candidateProfile25 === void 0 ? void 0 : _vm$candidateProfile25.nik_ktp) !== null && _vm$candidateProfile$0 !== void 0 ? _vm$candidateProfile$0 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Apply Date")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$1 = (_vm$candidateProfile26 = _vm.candidateProfile) === null || _vm$candidateProfile26 === void 0 ? void 0 : _vm$candidateProfile26.apply_date) !== null && _vm$candidateProfile$1 !== void 0 ? _vm$candidateProfile$1 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Seaferer Code")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$10 = (_vm$candidateProfile27 = _vm.candidateProfile) === null || _vm$candidateProfile27 === void 0 ? void 0 : (_vm$candidateProfile28 = _vm$candidateProfile27.personal_data) === null || _vm$candidateProfile28 === void 0 ? void 0 : _vm$candidateProfile28.seaferer_code) !== null && _vm$candidateProfile$10 !== void 0 ? _vm$candidateProfile$10 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("No. Tlp / Hp")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$11 = (_vm$candidateProfile29 = _vm.candidateProfile) === null || _vm$candidateProfile29 === void 0 ? void 0 : (_vm$candidateProfile30 = _vm$candidateProfile29.personal_data) === null || _vm$candidateProfile30 === void 0 ? void 0 : _vm$candidateProfile30.hp_number) !== null && _vm$candidateProfile$11 !== void 0 ? _vm$candidateProfile$11 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nomor NPWP")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$12 = (_vm$candidateProfile31 = _vm.candidateProfile) === null || _vm$candidateProfile31 === void 0 ? void 0 : (_vm$candidateProfile32 = _vm$candidateProfile31.personal_data) === null || _vm$candidateProfile32 === void 0 ? void 0 : _vm$candidateProfile32.npwp_number) !== null && _vm$candidateProfile$12 !== void 0 ? _vm$candidateProfile$12 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Email")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$13 = (_vm$candidateProfile33 = _vm.candidateProfile) === null || _vm$candidateProfile33 === void 0 ? void 0 : (_vm$candidateProfile34 = _vm$candidateProfile33.personal_data) === null || _vm$candidateProfile34 === void 0 ? void 0 : _vm$candidateProfile34.email) !== null && _vm$candidateProfile$13 !== void 0 ? _vm$candidateProfile$13 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Alamat")])]), _c('td', {
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v(_vm._s((_vm$candidateProfile$14 = (_vm$candidateProfile35 = _vm.candidateProfile) === null || _vm$candidateProfile35 === void 0 ? void 0 : (_vm$candidateProfile36 = _vm$candidateProfile35.alamat_ktp) === null || _vm$candidateProfile36 === void 0 ? void 0 : (_vm$candidateProfile37 = _vm$candidateProfile36[0]) === null || _vm$candidateProfile37 === void 0 ? void 0 : _vm$candidateProfile37.alamat) !== null && _vm$candidateProfile$14 !== void 0 ? _vm$candidateProfile$14 : '-'))])])])])]) : _vm._e(), _c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary"
        }, [_vm._v("Reason Black List")]), _c('b-form-group', [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.optionBlacklistReasons,
            "size": "lg",
            "aria-placeholder": "Pilih Alasan"
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Pilih Alasan")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.form.blacklist.reason_off,
            callback: function callback($$v) {
              _vm.$set(_vm.form.blacklist, "reason_off", $$v);
            },
            expression: "form.blacklist.reason_off"
          }
        })], 1), _c('b-form-textarea', {
          attrs: {
            "rows": "3",
            "name": "remarks",
            "required": "",
            "placeholder": "Remarks..."
          },
          model: {
            value: _vm.form.blacklist.remarks,
            callback: function callback($$v) {
              _vm.$set(_vm.form.blacklist, "remarks", $$v);
            },
            expression: "form.blacklist.remarks"
          }
        })], 1), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "12"
          }
        }, [_c('span', [_c('b-button', {
          attrs: {
            "variant": "primary",
            "block": "",
            "disabled": _vm.loading
          },
          on: {
            "click": _vm.onSaveBlacklist
          }
        }, [_c('i', {
          staticClass: "fa fa-file-signature"
        }), _vm._v(" SUBMIT ")])], 1)])], 1)], 1)];
      }
    }])
  }), _c('b-sidebar', {
    attrs: {
      "id": "medical-checkup",
      "title": "MEDICAL CHECKUP",
      "width": "50%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var hide = _ref5.hide;
        return [_c('b-row', {
          staticClass: "m-3"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2",
          staticStyle: {
            "font-size": "14pt"
          }
        }, [_c('strong', [_vm._v("Medical Check Up")])]), _c('b-form-row', [_c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Check Up Name",
            "label-for": "checkup_name"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "text",
            "id": "checkup_name",
            "placeholder": "Check Up Name"
          }
        })], 1)], 1), _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Expired Date",
            "label-for": "expired_date"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "date",
            "id": "expired_date"
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show")])], 1)], 1), _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "File Check Up",
            "label-for": "file_medical_checkup"
          }
        }, [_c('div', {
          staticClass: "custom-file"
        }, [_c('input', {
          staticClass: "custom-file-input",
          attrs: {
            "type": "file",
            "id": "validatedCustomFile",
            "required": ""
          }
        }), _c('label', {
          staticClass: "custom-file-label",
          attrs: {
            "for": "validatedCustomFile"
          }
        }, [_vm._v("Browse file...")])]), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" File Type * : "), _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v(".pdf / Maks 3 MB")])], 1)])], 1)], 1), _c('b-button', {
          staticClass: "mb-3 mr-1",
          attrs: {
            "variant": "success"
          }
        }, [_c('i', {
          staticClass: "fa fa-plus pr-0"
        }), _vm._v(" Add Document")]), _c('b-button', {
          staticClass: "mb-3 mr-1",
          attrs: {
            "variant": "danger"
          }
        }, [_c('i', {
          staticClass: "fa fa-minus pr-0"
        }), _vm._v(" Delete Document")])], 1), _c('b-button', {
          attrs: {
            "variant": "primary",
            "block": ""
          }
        }, [_c('i', {
          staticClass: "fa fa-file-signature"
        }), _vm._v(" SUBMIT ")])], 1)], 1)];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "delete-crew",
      "size": "md",
      "title": "HAPUS CREW",
      "cancel-title": "Close",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var hide = _ref6.hide;
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-textarea', {
          staticClass: "mb-2",
          attrs: {
            "rows": "3",
            "name": "remarks",
            "required": "",
            "placeholder": "Remarks..."
          },
          model: {
            value: _vm.delete_remarks,
            callback: function callback($$v) {
              _vm.delete_remarks = $$v;
            },
            expression: "delete_remarks"
          }
        }), _c('b-button', {
          attrs: {
            "variant": "primary",
            "block": ""
          },
          on: {
            "click": _vm.onDeleteCrew
          }
        }, [_vm._v("Hapus Crew")])], 1)], 1)];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "delete-candidate",
      "size": "md",
      "title": "HAPUS CANDIDATE",
      "cancel-title": "Close",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var hide = _ref7.hide;
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-textarea', {
          staticClass: "mb-2",
          attrs: {
            "rows": "3",
            "name": "remarks",
            "required": "",
            "placeholder": "Remarks..."
          },
          model: {
            value: _vm.delete_remarks,
            callback: function callback($$v) {
              _vm.delete_remarks = $$v;
            },
            expression: "delete_remarks"
          }
        }), _c('b-button', {
          attrs: {
            "variant": "primary",
            "block": ""
          },
          on: {
            "click": _vm.onDeleteCandidate
          }
        }, [_vm._v("Hapus Candidate")])], 1)], 1)];
      }
    }])
  }), _c('b-sidebar', {
    attrs: {
      "id": "slideExpiredCrew",
      "title": "Expired Crew",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var hide = _ref8.hide;
        return [_c('SlideExpiredCrew', {
          attrs: {
            "optionsCompanies": _vm.optionsCompanies
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideExpiredCrew,
      callback: function callback($$v) {
        _vm.slideExpiredCrew = $$v;
      },
      expression: "slideExpiredCrew"
    }
  }), _c('b-sidebar', {
    attrs: {
      "id": "slideExpiredCrewMonth",
      "title": "Expired 1 Month Crew",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var hide = _ref9.hide;
        return [_c('SlideExpiredCrewMonth', {
          attrs: {
            "optionsCompanies": _vm.optionsCompanies
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideExpiredCrewMonth,
      callback: function callback($$v) {
        _vm.slideExpiredCrewMonth = $$v;
      },
      expression: "slideExpiredCrewMonth"
    }
  }), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "slideExpiredCocCop",
      "title": "Expired ".concat(_vm.action == 'COC' ? 'COC' : 'COP'),
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref0) {
        var hide = _ref0.hide;
        return [_c('SlideExpiredCocCop', {
          attrs: {
            "list": _vm.expiredCopCocData,
            "exportCocCop": _vm.exportCocCop,
            "loading": _vm.loadingCopCocExpired,
            "action": _vm.action,
            "getListExpiredCocCop": _vm.getListExpiredCocCop
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideExpiredCocCop,
      callback: function callback($$v) {
        _vm.slideExpiredCocCop = $$v;
      },
      expression: "slideExpiredCocCop"
    }
  })], 1), _c('b-sidebar', {
    attrs: {
      "id": "slideListMCU",
      "title": "Expired Medical Check Up Crew",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('SlideListMCU')];
      },
      proxy: true
    }]),
    model: {
      value: _vm.slideListMCU,
      callback: function callback($$v) {
        _vm.slideListMCU = $$v;
      },
      expression: "slideListMCU"
    }
  }), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "slideListBirthday",
      "title": "List Birthday Crew",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref1) {
        var hide = _ref1.hide;
        return [_c('SlideListBirthday')];
      }
    }]),
    model: {
      value: _vm.slideListBirthday,
      callback: function callback($$v) {
        _vm.slideListBirthday = $$v;
      },
      expression: "slideListBirthday"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "slideListPkl",
      "title": "List of Crew PKL Not Completed",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref10) {
        var hide = _ref10.hide;
        return [_c('SlideListPkl', {
          attrs: {
            "fleetOptions": _vm.fleetOptions,
            "optionsCompanies": _vm.optionsCompanies
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideListPkl,
      callback: function callback($$v) {
        _vm.slideListPkl = $$v;
      },
      expression: "slideListPkl"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "slideNoticeSignOff",
      "title": "List Notice Sign Off Crew",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref11) {
        var hide = _ref11.hide;
        return [_c('SlideListNoticeSignOff', {
          attrs: {
            "fleetOptions": _vm.fleetOptions,
            "optionsPosition": _vm.optionsPosition,
            "optionsCompanies": _vm.optionsCompanies
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideNoticeSignOff,
      callback: function callback($$v) {
        _vm.slideNoticeSignOff = $$v;
      },
      expression: "slideNoticeSignOff"
    }
  })], 1)], 2)])])], 1), _c('b-modal', {
    attrs: {
      "id": "reject-modal",
      "size": "l",
      "title": "Reject (Navigation Equipment - Navigation Light)",
      "ok-title": "Save Changes",
      "cancel-title": "Close"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reason *",
      "label-for": "reason"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "reason",
      "rows": "2"
    }
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }